export default __webpack_public_path__ + "static/media/hero_bkg.f7d0810f.png";